// Connection Credibility Badge — reusable for profile cards, match lists, chat headers, etc.
//
// Score-driven visual: Exemplary purple ★★★★★, Trusted blue ★★★★, Reliable green ★★★,
// Building amber ★★, Needs Work red ★, Building Reputation gray (no calibration yet).

import React from 'react';
import { ShieldCheck, Star } from 'lucide-react';

export function CredibilityBadge({ credibility, size = 'sm', showScore = true, className = '' }) {
  if (!credibility?.tier) return null;
  const { tier, score, calibrated } = credibility;
  const dot = {
    sm: { px: 'px-1.5', py: 'py-0.5', txt: 'text-[10px]', icon: 10, gap: 'gap-1' },
    md: { px: 'px-2',   py: 'py-1',   txt: 'text-[11px]', icon: 12, gap: 'gap-1.5' },
    lg: { px: 'px-2.5', py: 'py-1',   txt: 'text-[12px]', icon: 14, gap: 'gap-1.5' },
  }[size];
  return (
    <span
      className={`inline-flex items-center ${dot.gap} ${dot.px} ${dot.py} rounded-full font-semibold ${dot.txt} ${className}`}
      style={{
        backgroundColor: `${tier.color}1A`,
        color: tier.color,
        border: `1px solid ${tier.color}33`,
      }}
      data-testid="credibility-badge"
      title={calibrated
        ? `Connection Credibility: ${score}/100 — ${tier.label}`
        : `${tier.label} — score calibrates after 5 message exchanges`}
    >
      {tier.stars > 0
        ? <ShieldCheck size={dot.icon} strokeWidth={2.4} />
        : <Star size={dot.icon} strokeWidth={2.2} />}
      <span>{tier.label}</span>
      {showScore && calibrated && (
        <span className="opacity-70 tabular-nums">{score}</span>
      )}
    </span>
  );
}
